module.exports = __webpack_public_path__ + "img/UTQUAI-7.b82c8c8b.jpg";